import { SET_API_ENDPOINT, SET_CANVAS_ORIGIN, SET_USER_TOKEN } from '@instructure/quiz-common';
export function setAPIEndpoint(endpoint) {
  return {
    type: SET_API_ENDPOINT,
    payload: endpoint
  };
}
export function setUserToken(token) {
  return {
    type: SET_USER_TOKEN,
    payload: token
  };
}
export function setCanvasOrigin(canvasHost) {
  return {
    type: SET_CANVAS_ORIGIN,
    payload: canvasHost
  };
}